import { useMemo } from 'react'
import { useQuery } from 'hooks'
import links, { getLinkWithParams } from 'links'


type AdsApiData = {
  data: {
    id: number
    main_image: string
    title: string
  }[]
  meta: {
    total: number
  }
}

type Ad = {
  title: string
  image: string
  to: string
}

const useAds = () => {
  const options = useMemo(() => ({
    url: '/api/site/kom_rekl',
    modifyResult: ({ data, meta }: AdsApiData) => {
      const ads = data?.map(({ id, title, main_image: image }) => ({
        title,
        image,
        to: getLinkWithParams(links.goodsAndServices.item, { itemId: id }),
      })) || []

      const adsTotal = meta?.total || 0

      return { ads, adsTotal }
    },
  }), [])

  const { data, isFetching, errors } = useQuery<{ ads: Ad[], adsTotal: number }>(options)

  const { ads, adsTotal } = useMemo(() => {
    if (data) {
      return {
        ads: data.ads,
        adsTotal: data.adsTotal,
      }
    }

    return {
      ads: [],
      total: 0,
    }
  }, [ data ])

  return {
    ads,
    adsTotal,
  }
}

export default useAds